import React from 'react'
import { formatToBRL } from 'brazilian-values'
import HelpIcon from '@material-ui/icons/Help'
import LightTooltip from 'ui/components/ContainerCommonPanels/LightTooltip'

const blacklistInfoText = (docType) => `Essa opção marcará a consulta como REPROVADA e o ${docType.toUpperCase()} será enviado para a lista de bloqueados.`

const isManualInputService = (service) => (
  service.service_id === 'processes_classifier' || service.service_id.includes('credit_score')
)

const confirmationMsg = (showConfirm) => (
  showConfirm ? ' Deseja prosseguir adicionando-o ao plano?' : ''
)

const additionalCostText = (cost, showConfirm = false) => {
  return `A execução deste serviço incorrerá em uma taxa adicional de ${formatToBRL(cost)} por consulta.${confirmationMsg(showConfirm)}`
}

const expensiveServiceText = (showConfirm = false) => {
  return `A execução deste serviço poderá ter um custo elevado, além do normal.${confirmationMsg(showConfirm)}`
}

const useProcessContingencyTooltipText = (
  <div>
    <p>
      Com essa opção ativa, caso algum serviço de processos (TJs, PJEs, TRFs, STF, STJ, Mandados de prisão e Improbidade administrativa) esteja inoperante por mais de 30 minutos, o serviço Classificador de Processos é usado como contingência.
    </p>
    <p>
      Na pesquisa efetuada em contingência, o caso que tiver processo judicial (baseado nas palavras-chaves) fica com status pendente de processamento por até 48 horas.
    </p>
    <p>
      Neste período o sistema fica continuamente tentando realizar a consulta nos serviços que estão inoperantes, e se não obtenha sucesso o caso é marcado como Reprovado ou Em Atenção.
    </p>
  </div>
)

const useProcessContingencyTooltip = (
  <LightTooltip arrow title={useProcessContingencyTooltipText}>
    <HelpIcon style={{ verticalAlign: 'middle', fontSize: '1.9rem' }} />
  </LightTooltip>
)

const useProcessContingencyText = (
  <div>
    Usar como contigência quando serviços de processos (TJs, TRFs, STF, STJ, etc) estão fora do ar
    {' '}
    {useProcessContingencyTooltip}
  </div>
)

const creditScoreSliderText = () => {
  const creditScoreSliderTooltipText = (
    <div>
      <p>
        Se o score da pessoa for maior ou igual ao definido abaixo, a consulta é marcada como Aprovada, se não, é marcada como Reprovada/Em Atenção.
      </p>
      <p>
        Ex: Se definir o valor em 600, qualquer pessoa com score igual ou maior será Aprovada.
      </p>
    </div>
  )
  const creditScoreSliderTooltip = (
    <LightTooltip arrow title={creditScoreSliderTooltipText}>
      <HelpIcon style={{ verticalAlign: 'middle', fontSize: '1.9rem' }} />
    </LightTooltip>
  )

  return (
    <div>
      Defina o valor mínimo aceito no score:
      {' '}
      {creditScoreSliderTooltip}
    </div>
  )
}


export {
  additionalCostText,
  blacklistInfoText,
  creditScoreSliderText,
  expensiveServiceText,
  isManualInputService,
  useProcessContingencyText,
}
